export function scrollToTop() {
  const container = document.getElementById('disable-container');
  if (container) {
    container.scrollTo({ top: 0, behavior: 'instant' });
  }
}


export function scrollToElement(elementId: string) {
  const element = document.getElementById(elementId);
  const container = document.getElementById('disable-container');
  if (element && container) {
    const containerRect = element.getBoundingClientRect();
    const scrollToPosition = containerRect.top + container.scrollTop - 105;
    container.scrollTo({ top: scrollToPosition, behavior: 'instant' });

    element.style.transition = 'background-color 0.3s ease-in-out';
    element.classList.add('bg-primary-subtle');
    if (element.children.length > 0) {
      (element.children[0] as HTMLElement).style.transition = 'background-color 0.3s ease-in-out';
      (element.children[0] as HTMLElement).classList.add('bg-primary-subtle');
    }

    setTimeout(() => {
      element.style.transition = 'background-color 0.3s ease-in-out';
      element.classList.remove('bg-primary-subtle');
      if (element.children.length > 0) {
        element.children[0].classList.remove('bg-primary-subtle');
      }
    }, 1000);
  } else if (element) {
    element.scrollIntoView({ behavior: 'instant' });
  }
}